import React, { useState, useEffect } from 'react';
import { Phone, Mail, Menu, X } from 'lucide-react';
import { businessInfo } from '../mock';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
    }`}>
      {/* Top Bar */}
      <div className="bg-slate-900 text-white py-2">
        <div className="container mx-auto px-4 flex justify-between items-center text-sm">
          <div className="flex items-center gap-4">
            <a href={`tel:${businessInfo.phone}`} className="flex items-center gap-2 hover:text-amber-400 transition-colors">
              <Phone size={14} />
              <span>{businessInfo.phone}</span>
            </a>
            <a href={`mailto:${businessInfo.email}`} className="hidden md:flex items-center gap-2 hover:text-amber-400 transition-colors">
              <Mail size={14} />
              <span>{businessInfo.email}</span>
            </a>
          </div>
          <div className="text-amber-400">
            {businessInfo.location}
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <div className="bg-white p-2 rounded-lg shadow-sm">
              <img 
                src={businessInfo.logo} 
                alt={businessInfo.name} 
                className="h-16 md:h-20 w-auto object-contain"
                style={{ imageRendering: 'crisp-edges' }}
              />
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('home')} className="text-slate-700 hover:text-amber-600 transition-colors font-medium">
              Home
            </button>
            <button onClick={() => scrollToSection('services')} className="text-slate-700 hover:text-amber-600 transition-colors font-medium">
              Services
            </button>
            <button onClick={() => scrollToSection('gallery')} className="text-slate-700 hover:text-amber-600 transition-colors font-medium">
              Gallery
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="text-slate-700 hover:text-amber-600 transition-colors font-medium">
              Testimonials
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-slate-700 hover:text-amber-600 transition-colors font-medium">
              Contact
            </button>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Button 
              onClick={() => scrollToSection('contact')}
              className="bg-amber-500 hover:bg-amber-600 text-white font-semibold px-6"
            >
              Get Free Quote
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 flex flex-col gap-4">
            <button onClick={() => scrollToSection('home')} className="text-left text-slate-700 hover:text-amber-600 transition-colors font-medium">
              Home
            </button>
            <button onClick={() => scrollToSection('services')} className="text-left text-slate-700 hover:text-amber-600 transition-colors font-medium">
              Services
            </button>
            <button onClick={() => scrollToSection('gallery')} className="text-left text-slate-700 hover:text-amber-600 transition-colors font-medium">
              Gallery
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="text-left text-slate-700 hover:text-amber-600 transition-colors font-medium">
              Testimonials
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-left text-slate-700 hover:text-amber-600 transition-colors font-medium">
              Contact
            </button>
            <Button 
              onClick={() => scrollToSection('contact')}
              className="bg-amber-500 hover:bg-amber-600 text-white font-semibold"
            >
              Get Free Quote
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;